// extracted by mini-css-extract-plugin
module.exports = {"images":"styles_images__2lL3z","image":"styles_image__1ms5z"};